import {
  faDollar,
  faFilter,
  faGears,
  faList,
  faStore,
  faTrademark,
} from "@fortawesome/free-solid-svg-icons";
import { Provider } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import i18n from "./i18n";
import Layout from "./Layout";
import store from "./Store/store";
import Login from "./Views/Public/Login";

import "./App.css";
import "./index.css";
import "./Style/custom.scss";
import Brands from "./Views/Auth/Inputs/Brands";
import Categories from "./Views/Auth/Inputs/Categories";
import Items from "./Views/Auth/Inputs/Items";
import Prices from "./Views/Auth/Inputs/Prices";
import ItemSpecs from "./Views/Auth/Inputs/Specs";
import Outlets from "./Views/Auth/Inputs/Outlets";

export const routes = [
  {
    name: i18n.t("Services.Prices.Prices"),
    path: "prices",
    icon: faDollar,
    Comp: <Prices />,
  },
  {
    name: i18n.t("Services.ItemSpecs.ItemSpecs"),
    path: "item-specs",
    icon: faGears,
    Comp: <ItemSpecs />,
  },
  {
    name: i18n.t("Services.Items.Items"),
    path: "items",
    icon: faList,
    Comp: <Items />,
  },
  {
    name: i18n.t("Services.Categories.Categories"),
    path: "categories",
    icon: faFilter,
    Comp: <Categories />,
  },
  {
    name: i18n.t("Services.Outlets.Outlets"),
    path: "outlets",
    icon: faStore,
    Comp: <Outlets />,
  },
  {
    name: i18n.t("Services.Brands.Brands"),
    path: "brands",
    icon: faTrademark,
    Comp: <Brands />,
  },
];

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Layout>
          {store.getState().auth.user ? (
            <Routes>
              {routes.map(({ path, Comp }, i) => (
                <Route path={path} element={Comp} key={i} />
              ))}

              <Route path="*" element={<Navigate to="/prices" replace />} />
            </Routes>
          ) : (
            <Routes>
              <Route path="*" element={<Login />} />
            </Routes>
          )}
        </Layout>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
